import DefaultInterface from "./fr";
//  import { SUPPORTED_LANGUAGE } from "../content";
import { InterfaceText } from "../types";
// default language is the first language defined in array
export const SUPPORTED_LANGUAGE = ["fr", "en"] as const;

const interfaceList: InterfaceText[] = [];

const importInterfaceFiles = async () => {
  for (let i = 0, n = SUPPORTED_LANGUAGE.length; i < n; i++) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const newInterface: { default: InterfaceText } = await import(`./${SUPPORTED_LANGUAGE[i]}`);
    interfaceList.push(newInterface.default);
  }
};

const getInterface = async (lang: typeof SUPPORTED_LANGUAGE[number]): Promise<InterfaceText> => {
  if (interfaceList.length === 0) {
    await importInterfaceFiles();
  }

  let interfaceText: InterfaceText = DefaultInterface;
  if (interfaceList.length > 1) {
    for (let i = 0, n = interfaceList.length; i < n; i++) {
      const parsedInterface: InterfaceText = interfaceList[i];
      if (parsedInterface.language === lang) {
        interfaceText = parsedInterface;
        break;
      }
    }
  }

  return interfaceText;
};

export default getInterface;

export const defaultInterface = DefaultInterface;
